<template>
  <div class="activity-page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索活动名称或地点" clearable @clear="search">
        <template #append><el-button @click="search">搜索</el-button></template>
      </el-input>
    </div>
    <el-row :gutter="20" v-loading="loading">
      <el-col v-for="item in list" :key="item.id" :xs="24" :sm="12" :md="8">
        <div class="activity-card" @click="$router.push('/activity/detail/' + item.id)">
          <el-image :src="item.cover_img || '/static/images/logo.jpg'" fit="cover" class="cover" />
          <div class="info">
            <h3>{{ item.title }}</h3>
            <p class="address">{{ item.address || '地点待定' }}</p>
            <div class="time-list">
              <div class="time-row">
                <span class="time-label">活动</span>
                <span class="time-value">{{ formatTimeRange(item.start_time, item.end_time) }}</span>
              </div>
              <div class="time-row">
                <span class="time-label">报名</span>
                <span class="time-value">{{ formatOptionalRange(item.signup_start_time, item.signup_end_time, '报名时间不限') }}</span>
              </div>
              <div class="time-row">
                <span class="time-label">签到</span>
                <span class="time-value">{{ formatCheckinRange(item) }}</span>
              </div>
            </div>
            <div class="activity-footer">
              <span class="price">¥{{ item.price }}</span>
              <span class="quota">余 {{ item.total_quota > 0 ? item.remaining_quota : '不限' }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-empty v-if="!loading && list.length === 0" description="暂无活动" />
    <div class="pager" v-if="total > 0">
      <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="pageSize" v-model:current-page="page" @current-change="load" />
    </div>
  </div>
</template>
<script>
import activity from '@/api/activity';
import dayjs from 'dayjs';
export default {
  name:'activityList',
  data(){return{
    // 活动列表筛选和分页状态。
    loading:false,keyword:'',list:[],page:1,pageSize:12,total:0
  }},
  created(){this.load();},
  methods:{
    search(){this.page=1;this.load();},
    formatTime(value) {
      if (!value) return '';
      return dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD HH:mm') : value;
    },
    formatTimeRange(start, end) {
      if (!start && !end) return '时间待定';
      if (!start) return `至 ${this.formatTime(end)}`;
      if (!end) return `${this.formatTime(start)} 起`;
      const startTime = dayjs(start);
      const endTime = dayjs(end);
      if (!startTime.isValid() || !endTime.isValid()) {
        return `${start} 至 ${end}`;
      }
      if (startTime.format('YYYY-MM-DD') === endTime.format('YYYY-MM-DD')) {
        return `${startTime.format('YYYY-MM-DD HH:mm')} - ${endTime.format('HH:mm')}`;
      }
      return `${startTime.format('YYYY-MM-DD HH:mm')} 至 ${endTime.format('YYYY-MM-DD HH:mm')}`;
    },
    formatOptionalRange(start, end, emptyText) {
      if (!start && !end) return emptyText;
      return this.formatTimeRange(start, end);
    },
    formatCheckinRange(item) {
      if (item.checkin_start_time || item.checkin_end_time) {
        return this.formatTimeRange(item.checkin_start_time, item.checkin_end_time);
      }
      if (item.start_time && item.end_time) {
        const day = dayjs(item.start_time);
        const end = dayjs(item.end_time);
        if (day.isValid() && end.isValid()) {
          return `${day.format('YYYY-MM-DD')} 当天至 ${end.format('HH:mm')}`;
        }
      }
      return '按活动时间签到';
    },
    // 用户端只展示已上架且未结束的活动，规则由后端兜底。
    async load(){this.loading=true;const res=await activity.list({keyword:this.keyword,page:this.page,page_size:this.pageSize});if(res){this.list=res.data.data||[];this.total=res.data.total||0;}this.loading=false;}
  }
};
</script>
<style scoped>
.activity-page {
  padding: 30px;
}

.toolbar {
  max-width: 420px;
  margin-bottom: 24px;
}

.activity-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 420px;
  margin-bottom: 20px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  transition: box-shadow 0.2s, transform 0.2s;
}

.activity-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.cover {
  width: 100%;
  height: 180px;
  flex: 0 0 180px;
}

.info {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 18px 18px;
}

.info h3 {
  margin: 0 0 10px;
  overflow: hidden;
  color: #222;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.address {
  margin: 5px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.45;
}

.time-list {
  margin-top: 8px;
}

.time-row {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  margin-top: 6px;
  color: #5f6673;
  font-size: 14px;
  line-height: 1.45;
}

.time-label {
  height: 22px;
  color: #409eff;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  background: #ecf5ff;
  border-radius: 4px;
}

.time-value {
  min-width: 0;
  word-break: break-word;
}

.activity-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 34px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid #f0f2f5;
  background: transparent;
}

.price {
  color: #f56c6c;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.quota {
  color: #7a8493;
  font-size: 14px;
  line-height: 1;
}

.pager {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
</style>
